import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '@modules/auth/_services/auth.service';
import { interval, Subscription } from 'rxjs';
import { switchMap, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-payment-processing-modal',
  templateUrl: './payment-processing-modal.component.html',
  styleUrls: ['./payment-processing-modal.component.scss'],
})
export class PaymentProcessingModalComponent implements OnInit, OnDestroy {
  protected isCancel: boolean = false;
  private pollingSubscription: Subscription;
  private isPolling = true;

  constructor(
    private dialogRef: MatDialogRef<PaymentProcessingModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { isCancel: boolean },
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    this.isCancel = this.data.isCancel;

    // Poll user profile every 5 seconds to check if payment or cancellation is completed
    this.pollingSubscription = interval(5000)
      .pipe(
        takeWhile(() => this.isPolling),
        switchMap(() => this.authService.getUserByToken())
      )
      .subscribe(user => {
        // Check if payment or cancellation is no longer pending
        if (user?.profile?.company &&
          !user.profile.company.pending_payment &&
          !user.profile.company.pending_cancel) {
          this.dismissModal();
        }
      });
  }

  ngOnDestroy() {
    this.isPolling = false;
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
    }
  }

  private dismissModal() {
    this.isPolling = false;
    this.dialogRef.close();
  }
}
